import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button } from "antd";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import React, { useRef, useState } from "react";
import "./invoiceModal.scss";
import PrintableComponent from "./printable";

const InvoiceModal = ({ invoice, onClose }) => {
  const printRef = useRef();
  const [printingStatus, setPrintingStatus] = useState(false);

  const downloadAsPDF = () => {
    setPrintingStatus(true);
    window.setTimeout(async () => {
      try {
        const printable = document.getElementById("printable_component");
        if (!printable) return;

        const canvas = await html2canvas(printable, {
          scale: 2,
          backgroundColor: "#ffffff",
          useCORS: true,
        });

        const imgData = canvas.toDataURL("image/jpeg", 0.92);
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        const pageHeight = pdf.internal.pageSize.getHeight();
        let heightLeft = pdfHeight;
        let position = 0;

        pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          position = heightLeft - pdfHeight;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, pdfHeight);
          heightLeft -= pageHeight;
        }

        const ref = String(invoice?.reference_id || "invoice").replace(/\s+/g, "-");
        pdf.save(`WOWzer-invoice-${ref}.pdf`);
      } catch (err) {
        console.error("Invoice PDF export failed:", err);
      } finally {
        setPrintingStatus(false);
      }
    }, 200);
  };

  const handleBrowserPrint = () => {
    const root = document.documentElement;
    root.classList.add("invoice-print-active");
    const cleanup = () => {
      root.classList.remove("invoice-print-active");
      window.removeEventListener("afterprint", cleanup);
    };
    window.addEventListener("afterprint", cleanup);
    window.setTimeout(() => window.print(), 50);
  };

  return (
    <div className="invoice-modal">
      <div className="invoice-modal__toolbar no-print">
        <div className="invoice-modal__toolbar-actions">
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            loading={printingStatus}
            onClick={downloadAsPDF}
          >
            Download PDF
          </Button>
          <Button icon={<PrinterOutlined />} onClick={handleBrowserPrint}>
            Print
          </Button>
          <span className="invoice-modal__print-hint">
            In the print dialog, turn off &quot;Headers and footers&quot; for a clean page.
          </span>
        </div>
        {onClose ? (
          <Button onClick={onClose}>Close</Button>
        ) : null}
      </div>

      <div className="invoice-modal__scroll">
        <PrintableComponent
          ref={printRef}
          invoice={invoice}
          isPrinting={printingStatus}
        />
      </div>
    </div>
  );
};

export default InvoiceModal;
